import React from "react"
import { Box, Center ,Text, VStack,Heading,Grid, Wrap, HStack,Button,Divider,Image} from "@chakra-ui/react"
import scholarshipIcon from "./scholarship.svg"

export default function Dynamic(){
   
  return (
   
    
    <Box
    w="200px"
    display="flex"
    border="6px"
    borderColor="red"
    rounded="full"
    boxShadow="dark-lg"
    backgroundColor="green"
    transition="transform 0.3s ease-in-out" // Add transition for smooth effect
    _hover={{
      transform: 'scale(1.1)', // Increase size on hover
      boxShadow: '0 0 10px gray', // Green box shadow on hover
    }}
  >
    <Center
      w={["200px", "200px", "200px"]}
      border="6px"
      borderColor="red"
      px="10px"
      rounded="xl"
      boxShadow="black-lg"
      overflow="hidden"
    >
      <a href={`${process.env.REACT_APP_FRONTEND_URL}/scholarship/form`}>
        <HStack>
          <Image src={scholarshipIcon} w="50px" color="green" />
          <Text fontFamily="Arvo" fontSize="md" color="white">
            Scholarship Apply
          </Text>
        </HStack>
      </a>
    </Center>
  </Box>
     
  )

}

